import { Coloring } from "@/components/Elements/Layouts/Coloring";
import { HStack, VStack } from "@/components/Elements/Layouts/Stack";
import { RealtorState } from "@/store/realtorState";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { Header } from "./Header";

import header from "@/assets/images/header.png";
import { TransionFlash } from "@/components/Elements/Transition/TransionFlash";
import { BackNavigaterButton } from "@/features/LG/components/shared";

interface Props {
  returnUrl?: string;
  hideReturn?: boolean;
  title: React.ReactNode;
}

const HSpacer = styled.div`
  height: 60px;
`;

const TopSpacer = styled.div`
  height: 37px;
`;

const BackgroundImage = styled.div`
  background-image: url(${header});
  background-size: cover;
`;

const UpperZone = styled.div`
  position: relative;
  /* top: 10px; */
  padding: 10px;
  color: white;
  width: 100%;
  @media screen and (min-width: 540px) {
    width: 540px;
  }
`;

const Card = styled.div`
  background-color: #fff;
  position: relative;
  top: -60px;
  border-radius: 16px;
  min-height: 100px;
  padding: 30px;
  width: 100%;
  @media screen and (min-width: 540px) {
    border: 1px;
    width: 540px;
  }
`;

export const Layout: React.FC<Props> = (props) => {
  const [realtor] = useRecoilState(RealtorState);

  const location = useLocation();
  return (
    <>
      <Header />
      <TransionFlash key={location.key}>
        <Coloring backgroundColor={realtor.color.main}>
          <BackgroundImage>
            <HStack justifyContent="center" alignItems="center">
              <UpperZone>
                {!props.hideReturn ? (
                  <>
                    <BackNavigaterButton returnUrl={props.returnUrl} />
                  </>
                ) : (
                  <TopSpacer />
                )}
                <VStack spacing={3} alignItems="center" justifyContent="center">
                  {props.title}
                  <HSpacer />
                </VStack>
              </UpperZone>
            </HStack>
          </BackgroundImage>
        </Coloring>

        <Coloring backgroundColor={realtor.color.sub}>
          <HStack justifyContent="center">
            <Card>
              <VStack spacing={4} alignItems="stretch">
                <Outlet />
              </VStack>
            </Card>
          </HStack>
        </Coloring>
      </TransionFlash>
    </>
  );
};

export default Layout;
